export class Environment {
    public static isProduction() {
        return window.app.environment_name === 'production';
    }

    public static isPreupdate() {
        return window.app.environment_name === 'preupdate';
    }

    public static isPreprod() {
        return window.app.environment_name === 'preprod';
    }

    public static isDevelopment() {
        return window.app.environment_name === 'development';
    }

    public static isSocial() {
        return !Environment.isSite();
    }

    public static isSite() {
        return window.app.config.current_entry_point.includes('site');
    }

    public static isLanding() {
        return !!window.app.isLanding;
    }
}
